import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UniversalService } from '@commoncore/services/universal.service';
import EmblaCarousel, { EmblaCarouselType, EmblaOptionsType } from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

@Component({
  selector: 'common-landing-slider',
  standalone: true,
  imports: [],
  templateUrl: './landing-slider.component.html',
  styleUrl: './landing-slider.component.scss'
})
export class LandingSliderComponent {
  emblaNode: any;
  @ViewChild('viewport', { static: false }) viewport!: ElementRef;
  private embla: EmblaCarouselType | null = null;
  // slidesDesktop = [
  //   'assets/images/Card1.webp',
  //   'assets/images/Card2.webp',
  //   'assets/images/Card3.webp'
  // ];

  // slidesMob = [
  //   'assets/images/Card_Mobile1.webp',
  //   'assets/images/Card_Mobile2.webp',
  //   'assets/images/Card_Mobile3.webp'
  // ];
  // hotstar banner https://static.jiocloud.com/web2.0/landing/Images/Card2-1.webp
  // mob hotstar 'https://static.jiocloud.com/web2.0/landing/Images/Card_Mobile2-backup.webp'
  slidesDesktop = [
    'https://static.jiocloud.com/web2.0/landing/Images/Card3-1.webp',
    'https://static.jiocloud.com/web2.0/landing/Images/Card1-backup.webp',
    'https://static.jiocloud.com/web2.0/landing/Images/Card2.webp'
    
  ];

  slidesMob = [
    'https://static.jiocloud.com/web2.0/landing/Images/Card_Mobile3-1.webp',
    'https://static.jiocloud.com/web2.0/landing/Images/Card_Mobile1-4.webp',
    'https://static.jiocloud.com/web2.0/landing/Images/Card_Mobile2.webp'
  ];
  selectedIndex = 0;
  slides: string[];
  @HostListener('window:resize', [])
   resize(){
     this.universalService.checkDeviceType();
     if(this.universalService.isMobileDevice) {
      this.slides = this.slidesMob;
    }else{
      this.slides = this.slidesDesktop;
    }
   }
  constructor(public universalService:UniversalService,public router:Router){}
  ngOnInit(): void {
    console.log("reload");
    if(this.universalService.isMobileDevice) {
      this.slides = this.slidesMob;
    }else{
      this.slides = this.slidesDesktop;
    }
    /*this.emblaNode = document.querySelector('.embla');
    const options = { loop: true };
    const plugins = [Autoplay()];
    const emblaApi = EmblaCarousel(this.emblaNode, options, plugins);

    console.log(emblaApi.slideNodes()) // Access API*/
  }

  ngAfterViewInit(): void {
    const options: EmblaOptionsType = {
      align: 'center',
      loop: true,
      skipSnaps: false
    };
  
    const autoplay = Autoplay({ delay: 4000, stopOnMouseEnter: true });
    const plugins = [autoplay];
  
    this.emblaNode = EmblaCarousel(this.viewport.nativeElement, options, plugins);
  
    this.emblaNode.on('select', this.onSelect);
    this.onSelect();
  
    // Resume autoplay on mouse leave
    this.viewport.nativeElement.addEventListener('mouseleave', () => {
      autoplay.play(); // resumes autoplay
    });
  
    // Resume autoplay on touch end (for mobile)
    this.viewport.nativeElement.addEventListener('touchend', () => {
      autoplay.play();
    });
  }

  scrollPrev(): void {
    if (this.emblaNode) this.emblaNode.scrollPrev();
  }

  scrollNext(): void {
    if (this.emblaNode) this.emblaNode.scrollNext();
  }

  onSelect = (): void => {
    if (!this.emblaNode) return;
    this.selectedIndex = this.emblaNode.selectedScrollSnap();
  };

  scrollToSlide(index: number): void {
    this.emblaNode?.scrollTo(index);
  }



  ngAfterContentInit(): void {
  }
  ngOnDestroy() {
    if (this.emblaNode) this.emblaNode.destroy();
    let htmlElem = document.getElementsByTagName('html')[0];
    htmlElem.setAttribute("data-theme", "light");
    if (this.emblaNode) this.emblaNode.destroy();
  }

  carousalRedirection(index){
    // var baseUrl =  environment.baseUrl + "/signin"
    // window.open(baseUrl,'_self', "noopener, noreferrer");
    this.router.navigate(['/signin'])
    // console.log("hjsbjxa",index)
    // if(index == 0){
    //   baseUrl = baseUrl+ "features"
    //   window.open(baseUrl,'_blank', "noopener, noreferrer");
    // }else if(index == 1){
    //   baseUrl = baseUrl+ "features?id=albums-memories"
    //   window.open(baseUrl,'_blank', "noopener, noreferrer");
    // }else if(index == 2){
    //   document.getElementById('digilocker').scrollIntoView({ behavior: "instant", block: "start" });
    // } 
  }

}